<template>
  <v-icon
    v-if="campaignPreviewLoading"
    class="ov-spin"
    name="ri-loader-5-line"
    height="1em"
    width="1em"
    scale="1.5"
  />
  <span v-if="!campaignPreviewLoading">
    <Alert
      v-if="!campaignsPreview || !campaignsPreview.data || !token"
      :isShowing="true"
      alertMessage="Unfortunately the offer previews have expired. Please contact your AM for
      updated details."
      type="error"
  /></span>

  <section class="p-4">
    <div
      v-if="
        campaignsPreview && campaignsPreview.data && !campaignPreviewLoading
      "
      style="max-width: 62rem; margin: auto"
    >
      <div class="flex flex-wrap justify-between mb-6 text-sm">
        <div>
          <span class="text-base-content/70">For:</span>
          <span v-if="campaignsPreview.data" class="font-semibold ml-2">{{
            campaignsPreviewData.mail.toEmail
          }}</span>
        </div>
        <div class="text-base-content/50">
          <span>* Details as of {{ prettyCreatedAt }}</span>
        </div>
      </div>

      <CampaignPreview
        :campaigns="campaignsPreviewData.campaigns"
        :publisherOptions="{}"
      ></CampaignPreview>
    </div>
  </section>
</template>

<script setup>
import { computed, ref } from "vue"
import { useRoute } from "vue-router"
import { useQuery } from "@vue/apollo-composable"
import { DateTime } from "luxon"
import CampaignPreview from "@/pages/campaigns/CampaignPreview.vue"
import GET_CAMPAIGN_PREVIEW from "@/graphql/Campaign-backup/GetCampaignPreview.gql"

const route = useRoute()
const token = ref(route.params.token)

const { result: campaignsPreviewResult, loading: campaignPreviewLoading } =
  useQuery(GET_CAMPAIGN_PREVIEW, {
    id: token.value,
  })
const campaignsPreview = computed(
  () => campaignsPreviewResult.value?.campaignsPreview,
)

const campaignsPreviewData = computed(() => {
  const data = campaignsPreview.value?.data
  return data ? JSON.parse(data) : {}
})

const prettyCreatedAt = computed(() => {
  const dateTime = DateTime.fromFormat(
    campaignsPreview.value?.createdAt,
    "yyyy-MM-dd HH:mm:ss",
  )

  return dateTime.toFormat("MMMM dd, yyyy")
})
</script>
<style scoped></style>
